import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';
import { VerifyIbRepositionPayload } from '../interfaces/verify-ib-reposition-payload.interface';

@Injectable({
  providedIn: 'root',
})
export class IbRepoVerificationService {
  private readonly httpClient = inject(HttpClient);

  verify(blockTimeRecordId: string, payload: VerifyIbRepositionPayload): Observable<void> {
    const url = `${environment.apiHostV2}/block-time-records/${blockTimeRecordId}/ib-reposition-verification`;
    return this.httpClient.put<void>(url, payload);
  }
}
